import { Project } from '@brg/api';
import { FC } from 'react';
import { getProtectStatus } from 'shared/helpers/protectStatus';

export const ProtectStatus: FC<{ project: Project, visible: boolean }> = ({ project, visible }) => (
    <div style={{ display: visible ? 'inline-block' : 'none'}}>{`PROTECT STATUS: ${getProtectStatus(project)}`}</div>
)import { Project } from '@brg/api';
import { FC } from 'react';
import { getProtectStatus } from 'shared/helpers/protectStatus';

export const ProtectStatus: FC<{ project: Project, visible: boolean }> = ({ project, visible }) => (
    <div style={{ display: visible ? 'inline-block' : 'none'}}>{`PROTECT STATUS: ${getProtectStatus(project)}`}</div>
)